import React, { useEffect, useMemo, useState } from "react";
import {
  BrowserRouter,
  HashRouter,
  Outlet,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import "../src/styles/App.css";
import "./i18n/i18n";

import LoadingPage from "./components/Loading/LoadingPage";
import ProgressBlock from "./components/ProgressBlock/ProgressBlock";
import { common_route, routes } from "./utils/routes";
import OverflowHidden from "./utils/OverflowHidden";
import ShouldHideMenu from "./utils/hideMenu";
import useDeviceType from "./hook/useDeviceType";
import { API_RELOAD, BACK_DASHBOARD, BALANCE_RELOAD } from "./constant";
import ShowGameDetail from "./components/ShowGameDetail";
import { BasicApi } from "./api/basicApi";
import { allGameList, allGamePlatform, allGameType } from "./api/fakeGame";
import LanguagePage from "./pages/Settings/components/LanguagePage";
import { CheckGoogleLogin } from "./hook/useGoogleLogin";
import NotFoundPage from "./components/ProgressBlock/NotFoundPage";
import Wrapper from "./components/Wrapper";
import CommonHelmet from "./components/Seo/helmet";
import "../src/styles/splide.css";
import DescriptionDashboard from "./pages/Game/gameDescription/descriptionDashboard";
import ServicePing from "./pages/Service/ServicePing";
import TagManager from "react-gtm-module";
import { ErrorBoundary } from "react-error-boundary";
import Echo from "laravel-echo";
import Cookies from "js-cookie";
import { useChannelListener } from "./hook/useChannelListener";
import { notice } from "./redux/action/action";
import { cleanMemberInfo } from "./redux/action/member/memberAction";

const tagManagerArgs = {
  gtmId: "GTM-KH7FG9T",
};

TagManager.initialize(tagManagerArgs);

function App() {
  const dispatch = useDispatch();
  const isDarkMode = useSelector((state) => state.isTheme === "dark");

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname?.includes("nAdmin3")) {
      window.location.href = BACK_DASHBOARD;
    }
  }, []);

  useChannelListener("userBalance", "BalanceUpdated", (e) => {
    if (e?.message === "reload") {
      dispatch({ type: "GET_BALANCE", navigate: navigate });
    }
    console.log(e);
  });

  useChannelListener("listenTokenChanger", "ListenTokenChanger", (e) => {
    if (e?.tmpToken !== Cookies.get("tmpToken")) {
      dispatch({ type: "USER_LOGOUT", navigate: navigate });
    }
    console.log(e);
  });

  const deviceType = useDeviceType();
  const hideMenu = ShouldHideMenu();

  useEffect(() => {
    const className = "dark";
    const bodyClasses = document.body.classList;

    isDarkMode ? bodyClasses.add(className) : bodyClasses.remove(className);
  }, [isDarkMode]);

  useEffect(() => {
    CheckGoogleLogin(dispatch)();

    BasicApi(dispatch)();
    dispatch({ type: "INITIALIZE_API", navigate: navigate });
  }, []);

  const languagePop = useSelector((state) => state.isLanguagePop);
  const comissionListPop = useSelector((state) => state.isComissionListPop);
  const isGameDescriptionConfig = useSelector(
    (state) => state.isGameDescriptionPop
  );

  useEffect(() => {
    const fetchDataPeriodically = () => {
      dispatch({ type: "UPDATE_DATA_PERIODICALLY", navigate: navigate });
    };

    const apiIterval = setInterval(() => {
      fetchDataPeriodically();
    }, API_RELOAD);

    return () => clearInterval(apiIterval);
  }, []);

  return (
    <ErrorBoundary fallback={<div>&nbsp;</div>}>
      <CommonHelmet />
      {/* <MenuBar /> */}
      <section
        className={`${
          deviceType === "PC"
            ? hideMenu
              ? " w-full"
              : "pl-[320px] w-full"
            : ""
        }`}
      >
        <Routes location={location}>
          {routes.map((route, index) => {
            return (
              <Route key={route.path} path={route.path} element={route.element}>
                {common_route?.map((child, index) => {
                  return (
                    <Route
                      key={child.path}
                      exact={child.exact}
                      path={`${child.path}`}
                      element={
                        <OverflowHidden>
                          {child.element}
                          <Outlet key={child.path} />
                        </OverflowHidden>
                      }
                    >
                      {child.children?.map((item) => {
                        return (
                          <Route
                            exact={item.exact}
                            key={item.path}
                            path={`${item.path}`}
                            element={
                              <>
                                {item.element}
                                <Outlet />
                              </>
                            }
                          />
                        );
                      })}
                    </Route>
                  );
                })}
              </Route>
            );
          })}
          <Route
            path="*"
            element={
              <Wrapper>
                <NotFoundPage />
              </Wrapper>
            }
          />
        </Routes>
      </section>
      <ProgressBlock />
      {languagePop && <LanguagePage />}
      {isGameDescriptionConfig?.state === true && <DescriptionDashboard />}
    </ErrorBoundary>
  );
}

export default React.memo(App);
